import React from 'react';
import { useEffect } from 'react';

const Payment = () => {
    useEffect(() => {
        document.title = 'NASCAR — Оплата';
    }, []);

    return <div className="page">
        <section>
            <h2>Оплата</h2>

            <p>Мы обеспечили возможность выбора вами лично желаемой формы оплаты при покупке (полная оплата или частями). Вне зависимости от выбранного варианта оплаты, расчет производится только в белорусских рублях.</p>
            <p>Вся информация и персональные данные, полученные от вас (включая, но не ограничиваясь: имя, фамилия, телефон, адрес электронной почты и т.д.), надежно хранятся в нашей базе данных в соответствии с действующим законодательством и не передаются третьим лицам.</p>

            <h3>В нашей компании вы можете приобрести любую технику с оплатой частями — без переплат и с максимальной выгодой. Мы предлагаем гибкие условия на всю продукцию, включая электроскутеры, трициклы, мотоциклы, электросамокаты и т.п.</h3>

            {/* <p>Оплата частями — это:</p>
            <ul>
                <li>Рассрочка от финансовых — без процентов и переплат</li>
                <li>Кредит от банков-партнёров — по сниженным ставкам</li>
                <li>Лизинг — для физических и юридических лиц</li>
            </ul>

            <p>Условия:</p>
            <ul>
                <li>Срок: от 1 года до 5 лет</li>
                <li>Досрочное погашение — без штрафов</li>
                <li>Минимальный процент по кредитам</li>
                <li>Одобрение всем гражданам Республики Беларусь</li>
            </ul>

            <p>Оформление полностью онлайн:</p>
            <ul>
                <li>Нужен только паспорт и согласие</li>
                <li>Никуда ехать не нужно</li>
                <li>Решение — в течение 5 минут</li>
            </ul> */}
        </section>
    </div>;
};

export default Payment;
